import React from "react";
import { Menu } from "antd";
import { MenuInfo } from "rc-menu/lib/interface";
import { DashType } from "@/features/dashboard";

import { MenuMap } from "./constant";
import { usePerformanceContext } from "./hook";

export default () => {
  const { selectedKey, setSelectedKey } = usePerformanceContext();

  return (
    <Menu mode={"inline"} selectedKeys={selectedKey} onClick={onMenuClick}>
      {Object.entries(MenuMap).map(([k, v]) => (
        <Menu.Item key={k}>{v}</Menu.Item>
      ))}
    </Menu>
  );

  function onMenuClick({ key }: MenuInfo) {
    const targetKey = key as DashType.PerformanceType;
    const index = selectedKey.indexOf(targetKey);
    if (index >= 0) {
      // Remove from menu
      if (selectedKey.length > 1) {
        selectedKey.splice(index, 1);
        setSelectedKey([...selectedKey]);
      }
    } else {
      // Add to menu
      setSelectedKey([...selectedKey, targetKey]);
    }
  }
};
